import React from "react";

export const Completedicon = () => {
  return (
    <svg
      width="6"
      height="5"
      viewBox="0 0 6 5"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 2.6747L0.598364 2.01011L2.09455 3.67052L5.40109 0L6 0.664285L2.09455 5L0 2.6747Z"
        fill="#1C123F"
      />
    </svg>
  );
};
